import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { PageTitle, Input, Button, Loading } from '../root/components/common'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../root/actions'
import { getRoleName } from '../../utils'
import { DialogOpener } from '../root/components/common/dialog-opener'
import { ChangePassword } from './change-password'
import { NotificationItem } from './components/notification-item'
import { SectionTitle } from './components/section-title'
import { UserPermissions } from 'web/src/services/permissions'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: '100%'
    },
    detailsWrapper: {
        // width: 900,
        marginTop: '50px',
        display: 'flex'
    },
    input: {
        marginBottom: 15
    },
    detailsRow: {
        display: 'flex',
        marginBottom: 10,
        alignItems: 'center'
    },
    detailsNameColumn: {
        flex: 1,
        color: theme.quaternary,
        fontWeight: 'bold'
    },
    detailsValueColumn: {
        flex: 2,
        display: 'flex'
    },
    detailsInfoWrapper: {
        marginBottom: 30,
        marginTop: 20
    },
    modalButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 15
    },
    button: {
        marginBottom: 12
    },
    activeButton: {
        backgroundColor: theme.active,
        marginBottom: 12
    },
    pswdInputWrapper: {
        position: 'relative',
        width: 350
    },
    doneIcon: {
        position: 'absolute',
        color: theme.active,
        top: 10,
        right: -35
    },
    notificationsBlock: {
        marginTop: 50
    },
    accountSettingsHeader: {
        fontSize: 20,
        fontWeight: '100',
        fontFamily: theme.fontFamily
    },
    organisationSection: {
        marginLeft: '100px'
        // width: 500
    }
}))

export default function Profile() {
    const classes = useStyles()
    const dispatch = useDispatch()

    const loggedInUser = useSelector(state => state.main.user)
    const organisationData = useSelector(state => state.main.organisationData)
    const user = { ...loggedInUser }
    const { isLoading, locale } = useSelector(state => state.main)

    const [name, setName] = useState(user.name)
    // eslint-disable-next-line
    const [email, setEmail] = useState(user.email)
    const [phone, setPhoneNumber] = useState(user.phone_number || '')
    const [organisationPhone, setOrganisationPhone] = useState('')

    const [mailNotificationsEnabled, setMailNotificationsEnabled] = useState(
        user.mail_notification_enabled
    )
    const [smsNotificationEnabled, setSmsNotificationEnabled] = useState(
        user.sms_notification_enabled
    )
    const [pushNotificationEnabled, setPushNotificationEnabled] = useState(
        user.push_notification_enabled
    )
    const [notificateTriggered, setNotificateTriggered] = useState(
        user.notificate_triggered
    )
    const [notificateInactive, setNotificateInactive] = useState(
        user.notificate_inactive
    )
    const [notificateBattery, setNotificateBattery] = useState(
        user.notificate_battery
    )
    const [notificateTrapSet, setNotificateTrapSet] = useState(
        user.notificate_trap_set
    )
    const [notificateBackOnline, setNotificateBackOnline] = useState(
        user.notificate_back_online
    )

    const [
        notificateUnstableConnection,
        setNotificateUnstableConnection
    ] = useState(user.notificate_unstable_wifi)

    const [notificateBaitLow, setNotificateBaitLow] = useState(
        user.notificate_bait_low
    )

    const [
        notificateActivityThresholdReached,
        setNotificateActivityThresholdReached
    ] = useState(user.notificate_activity_threshold_reached)

    const [
        notificateBaitLowAndActivityThresholdReached,
        setNotificateBaitLowAndActivityThresholdReached
    ] = useState(user.notificate_bait_low_and_activity_threshold_reached)

    const isValidForSave = data => {
        const phoneRegex = /^[\d ()+-]+$/
        let ok = true
        if (data.name.length < 3) {
            ok = false
            dispatch(
                actions.enqueueSnackbar({
                    message: locale.settings.nameIsTooShort,
                    options: {
                        variant: 'warning'
                    }
                })
            )
        }

        if (phone.trim().length !== 0) {
            if (!phoneRegex.test(phone)) {
                ok = false
                dispatch(
                    actions.enqueueSnackbar({
                        message: locale.settings.phoneNumberErr,
                        options: {
                            variant: 'warning'
                        }
                    })
                )
            }
        }

        if (organisationPhone.trim().length !== 0) {
            if (!phoneRegex.test(organisationPhone)) {
                ok = false
                dispatch(
                    actions.enqueueSnackbar({
                        message: locale.settings.organisationPhoneNumberErr,
                        options: {
                            variant: 'warning'
                        }
                    })
                )
            }
        }

        return ok
    }

    const save = () => {
        const data = {
            name: name,
            phone_number: phone === '' ? null : phone,
            mail_notification_enabled: mailNotificationsEnabled,
            sms_notification_enabled: smsNotificationEnabled,
            push_notification_enabled: pushNotificationEnabled,
            notificate_triggered: notificateTriggered,
            notificate_inactive: notificateInactive,
            notificate_battery: notificateBattery,
            notificate_trap_set: notificateTrapSet,
            notificate_back_online: notificateBackOnline,
            notificate_unstable_wifi: notificateUnstableConnection,
            notificate_bait_low: notificateBaitLow,
            notificate_activity_threshold_reached: notificateActivityThresholdReached,
            notificate_bait_low_and_activity_threshold_reached: notificateBaitLowAndActivityThresholdReached
        }

        if (isValidForSave(data)) {
            dispatch(actions.profileUpdateRequest(data))
            if (UserPermissions.isAllOriginalGranted())
                dispatch(
                    actions.setOrganisationPhoneNumber({
                        customerId: user.original_customer_id,
                        organisation_phone_number: organisationPhone
                    })
                )
        }
    }

    const onAcceptSharedData = () => {
        dispatch(actions.reloadUser())
    }

    useEffect(() => {
        dispatch(actions.getProfileUser(user.id))
        if (UserPermissions.isAllOriginalGranted()) {
            dispatch(
                actions.getOrganisationDataRequest(user.original_customer_id)
            )
        }
    }, [])

    useEffect(() => {
        setOrganisationPhone(organisationData?.organisation_phone_number || '')
    }, [organisationData])

    // TODO shared data button make only visible when Redis instance is up
    // for checking active sessions

    return (
        <div className={classes.wrapper}>
            {isLoading && <Loading />}
            {!isLoading && (
                <React.Fragment>
                    <PageTitle title={locale.common.settings} />
                    <div className={classes.detailsWrapper}>
                        <div>
                            <h3 className={classes.accountSettingsHeader}>
                                {locale.common.accountSettings}
                            </h3>
                            <Input
                                className={classes.input}
                                label={locale.common.name}
                                type="text"
                                setValue={setName}
                                value={name}
                                onEnter={save}
                            />
                            <Input
                                className={classes.input}
                                label={locale.common.email}
                                type="text"
                                value={email}
                            />
                            <Input
                                className={classes.input}
                                label={locale.common.phone}
                                type="text"
                                setValue={value => setPhoneNumber(value)}
                                value={phone}
                                onEnter={save}
                            />
                            <div className={classes.detailsInfoWrapper}>
                                <div className={classes.detailsRow}>
                                    <div className={classes.detailsNameColumn}>
                                        {locale.common.role}:
                                    </div>
                                    <div className={classes.detailsValueColumn}>
                                        {getRoleName(
                                            {
                                                name: user.original_role_name,
                                                code: user.original_role
                                            },
                                            locale
                                        )}
                                    </div>
                                </div>
                                <div className={classes.notificationsBlock}>
                                    <SectionTitle
                                        title={
                                            locale.settings
                                                .notificationsChannels
                                        }
                                    />
                                    <NotificationItem
                                        label={
                                            locale.settings
                                                .pushNotificationsEnabled
                                        }
                                        onClick={(_, checked) =>
                                            setPushNotificationEnabled(checked)
                                        }
                                        checked={pushNotificationEnabled}
                                    />
                                    <NotificationItem
                                        label={
                                            locale.settings
                                                .emailNotificationsEnabled
                                        }
                                        onClick={(_, checked) =>
                                            setMailNotificationsEnabled(checked)
                                        }
                                        checked={mailNotificationsEnabled}
                                    />
                                    <SectionTitle
                                        title={
                                            locale.settings.notificationsEvents
                                        }
                                    />
                                    <NotificationItem
                                        label={
                                            locale.settings
                                                .trapsTriggeredNotificationsEnabled
                                        }
                                        onClick={(_, checked) =>
                                            setNotificateTriggered(checked)
                                        }
                                        checked={notificateTriggered}
                                    />
                                    <NotificationItem
                                        label={
                                            locale.settings
                                                .trapsInactiveemailNotificationsEnabled
                                        }
                                        onClick={(_, checked) =>
                                            setNotificateInactive(checked)
                                        }
                                        checked={notificateInactive}
                                    />
                                    <NotificationItem
                                        label={
                                            locale.settings
                                                .batteryEmptyNotificationsEnabled
                                        }
                                        onClick={(_, checked) =>
                                            setNotificateBattery(checked)
                                        }
                                        checked={notificateBattery}
                                    />
                                    <NotificationItem
                                        label={
                                            locale.settings
                                                .batterySetupNotificationsEnabled
                                        }
                                        onClick={(_, checked) =>
                                            setNotificateTrapSet(checked)
                                        }
                                        checked={notificateTrapSet}
                                    />
                                    <NotificationItem
                                        label={
                                            locale.settings
                                                .trapOnlineNotificationsEnabled
                                        }
                                        onClick={(_, checked) =>
                                            setNotificateBackOnline(checked)
                                        }
                                        checked={notificateBackOnline}
                                    />
                                    <NotificationItem
                                        label={
                                            locale.settings
                                                .unstableConnectionNotificationsEnabled
                                        }
                                        onClick={(_, checked) =>
                                            setNotificateUnstableConnection(
                                                checked
                                            )
                                        }
                                        checked={notificateUnstableConnection}
                                    />
                                    <NotificationItem
                                        label={
                                            locale.settings
                                                .baitLowNotificationsEnabled
                                        }
                                        onClick={(_, checked) =>
                                            setNotificateBaitLow(checked)
                                        }
                                        checked={notificateBaitLow}
                                    />
                                    <NotificationItem
                                        label={
                                            locale.settings
                                                .activityThresholdReachedNotificationsEnabled
                                        }
                                        onClick={(_, checked) =>
                                            setNotificateActivityThresholdReached(
                                                checked
                                            )
                                        }
                                        checked={
                                            notificateActivityThresholdReached
                                        }
                                    />
                                    <NotificationItem
                                        label={
                                            locale.settings
                                                .baitLowAndActivityThresholdReachedNotificationsEnabled
                                        }
                                        onClick={(_, checked) =>
                                            setNotificateBaitLowAndActivityThresholdReached(
                                                checked
                                            )
                                        }
                                        checked={
                                            notificateBaitLowAndActivityThresholdReached
                                        }
                                    />
                                </div>
                            </div>
                            <Button
                                onClick={onAcceptSharedData}
                                active
                                className={classes.button}
                            >
                                {locale.settings.acceptSharedData}
                            </Button>
                            <DialogOpener
                                dialog={(handleClose, dialogProps) => (
                                    <ChangePassword
                                        onClose={handleClose}
                                        {...dialogProps}
                                    />
                                )}
                            >
                                {handleOpen => (
                                    <Button
                                        onClick={handleOpen}
                                        className={classes.button}
                                    >
                                        {locale.common.changePassword}
                                    </Button>
                                )}
                            </DialogOpener>
                            <Button onClick={save} className={classes.button}>
                                {locale.common.save}
                            </Button>
                        </div>
                        {UserPermissions.isAllOriginalGranted() ? (
                            <div className={classes.organisationSection}>
                                <h3 className={classes.accountSettingsHeader}>
                                    {locale.common.organisationSettings}
                                </h3>
                                <div className={classes.detailsRow}>
                                    <div className={classes.detailsNameColumn}>
                                        {locale.common.organisation}:
                                    </div>
                                    <div className={classes.detailsValueColumn}>
                                        {user.original_customer_name}
                                    </div>
                                </div>
                                <div className={classes.detailsRow}>
                                    <div className={classes.detailsNameColumn}>
                                        {locale.common.organisationPhone}:
                                    </div>
                                    <div className={classes.detailsValueColumn}>
                                        <Input
                                            className={
                                                classes.organisationPhoneInput
                                            }
                                            label={
                                                locale.common.organisationPhone
                                            }
                                            type="text"
                                            setValue={value =>
                                                setOrganisationPhone(value)
                                            }
                                            value={organisationPhone}
                                            onEnter={save}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </React.Fragment>
            )}
        </div>
    )
}
